import Lenis from 'lenis';

export default class LenisScroll {
    static key = 'LenisScroll';

    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.initLenis();
    }

    initLenis() {
        this.lenis = new Lenis({
            duration: 1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            wheelMultiplier: 1,
            touchMultiplier: 1,
        });

        const raf = (time) => {
            this.lenis.raf(time);
            requestAnimationFrame(raf);
        };

        requestAnimationFrame(raf);
    }
}
